module.exports = __webpack_public_path__ + "static/images/components/NavigationArrow/images/arrow-right-disabled-big.2be6d748.png";


//////////////////
// WEBPACK FOOTER
// ./components/NavigationArrow/images/arrow-right-disabled-big.png
// module id = 2644
// module chunks = 11